export default "__VITE_ASSET__65Ok9t17__"